import axios from 'axios'
import { REACT_APP_API_URL } from '../config'

const APIClient = axios.create({
  baseURL: REACT_APP_API_URL
})

export default APIClient
